import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Wrapper } from './AuthorFilter.styled';
import { UserSelect } from '../../../../../../../components/_form';
import { IOption } from '../../../../../../../components/_form/Select/Select';
import { useTaskSidebarContext } from '../../../../../../../contexts/TaskSidebarContext';
import { useUsersQuery } from 'hooks/queries/useUsersQuery';
import { mapUsersToSelectOptions } from 'utilities/userSelectOption';

export const AuthorFilter: React.FC = () => {
  const { data: users = [] } = useUsersQuery();
  const usersList = useMemo(
    () => mapUsersToSelectOptions(users),
    [users]
  );
  const { t } = useTranslation();
  const {
    filters: { authors },
    setFilters
  } = useTaskSidebarContext();

  const selected = () =>
    usersList.filter((el) => authors.value.includes(el.value));

  const handleOnChange = (val: IOption[]) => {
    setFilters((prevState) => {
      return {
        ...prevState,
        authors: {
          label:
            val.length > 0
              ? t('authors') + ' - ' + val.map((el) => el.label).join(', ')
              : '',
          value: val.map((el) => el.value)
        }
      };
    });
  };

  return (
    <Wrapper>
      <UserSelect
        isMulti
        isClearable
        options={usersList}
        selectedOptions={selected()}
        onChange={handleOnChange}
      />
    </Wrapper>
  );
};
